import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AzureAD, { IAzureADFunctionProps, AuthenticationState } from "react-aad-msal";
import { Box } from "@material-ui/core";
import Header from "./components/common/Header";
import { LoginRequired } from "./pages/LoginRequired";
import { LoginInProgress } from "./pages/LoginInProgress";
import { authProvider } from "./authProvider";
import { Unauthorized } from "./pages/Unauthorized";
import { Container } from "./components/common/Container";
import { Footer } from "./components/common/Footer";
import Main from "./Main";

function App(): JSX.Element {
  const [apiVersion, setApiVersion] = useState();
  const [frontendVersion, setFrontendVersion] = useState();
  useEffect(() => {
    const fetchVersionData = async () => {
      const result = await fetch(process.env.PUBLIC_URL + "/frontend_version.json");
      if (result.ok) setFrontendVersion(await result.json());

      const apiResult = await fetch(`/api/v1/version`);
      if (apiResult.ok) setApiVersion(await apiResult.json());
    };
    fetchVersionData();
  }, []);

  return (
    <AzureAD provider={authProvider} forceLogin={false}>
      {({ authenticationState, accountInfo, login, logout }: IAzureADFunctionProps) => {
        const isInProgress = authenticationState === AuthenticationState.InProgress;
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;
        const isUnauthenticated = authenticationState === AuthenticationState.Unauthenticated;

        let view;
        if (isUnauthenticated) {
          view = <LoginRequired />;
        } else if (isInProgress) {
          view = <LoginInProgress />;
        } else if (isAuthenticated) {
          view = <Main />;
        } else {
          view = <Unauthorized />;
        }

        return (
          <Router>
            <Header
              maxWidth="lg"
              loggedUserName={accountInfo?.account.name}
              login={login}
              logout={logout}
              title="Saapumisseuranta"
            />
            <Container maxWidth="lg">
              <Box px={{ xs: 1, sm: 4 }} py={{ xs: 1, sm: 2 }} bgcolor="background.paper">
                {view}
              </Box>
            </Container>
            <Footer apiVersion={apiVersion} frontendVersion={frontendVersion} />
          </Router>
        );
      }}
    </AzureAD>
  );
}

export default App;
